import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing a table view extending JetView.
 */
export default class tableView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // Data table component
                            id: 'datatable', // Unique ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'edit', // Column ID for edit action
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    template: function (obj) {
                                        // Template for edit icon based on permissions
                                        if (!devConfig.getPermAction('TemplateEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>";
                                        } else {
                                            return '';
                                        }
                                    },
                                },
                                {
                                    id: 'detailTittle', // Column ID for detail action
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: _('Detalles'), // Tooltip for details
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>";
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for ID
                                    header: _('ID'), // Header text
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID for Type
                                    header: _('Tipo'), // Header text
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Language', // Column ID for Language
                                    header: _('Idioma'), // Header text
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Section', // Column ID for Section
                                    header: _('Sección'), // Header text
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click actions
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.show(
                                        '../partner.templates.emailTemplate?id=' + item.Id, // Show details for the selected item
                                    );
                                },
                                edit: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    $$('editTemplate').show(); // Show edit template
                                    $$('editform').setValues(item); // Set values in the edit form
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            autoConfig: false, // Disable auto configuration
                            pager: 'pagerA', // Pager ID
                            on: {
                                // Event handlers for datatable
                                onItemDblClick: (id) => {}, // Double-click event (empty)
                                onBeforeLoad: function () {
                                    // Show overlay before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide overlay after loading
                                },
                            },
                            ready: function () {
                                // Check if there are no items in the datatable
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // No data message
                                            '</div>',
                                    );
                                }
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        var url = devConfig.geturlApi() + 'Partners/GetTemplateEmailList'; // API URL for fetching email templates
        var filter = ''; // Filter string for API requests
        grid.showOverlay(
            "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                _('No hay datos') + // No data message
                '</div>',
        );
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        // Event listener for filter changes
        this.on(this.app, 'filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle non-object filter values
                    if (object[i][0] == 'Datepicker') {
                        if (object[i][1] !== ' ') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                            string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                        }
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filter values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + string1, // Load data with filters
            ).then(function (data) {
                data = data.json(); // Parse JSON response
                if (!data.HasError) {
                    if (data.Data.length > 0) {
                        this.hideOverlay(); // Hide overlay if data is present
                    } else {
                        grid.clearAll(); // Clear grid if no data
                        grid.showOverlay(
                            "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                _('No hay datos') + // No data message
                                '</div>',
                        );
                    }
                } else {
                    grid.clearAll(); // Clear grid on error
                    grid.showOverlay(
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // No data message
                            '</div>',
                    );
                    webix.message({
                        title: _('¡Error!'), // Error message title
                        type: 'alert-error', // Error message type
                        text: _('Ocurrio un error, comuniquese con soporte'), // Error message text
                    });
                }
            });
            filter = string1; // Update filter string
        });

        var datePopup = []; // Array to hold date options for popup
        var popup = ''; // Variable for add popup
        var popupAdd = ''; // Variable for edit popup
        const params = {
            Partner: id_partner, // Parameters for API request
        };

        // Fetch section template email options
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Partners/GetSectionTemplateEmailSelect', params, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    if (!resp.HasError) {
                        datePopup = resp.Data; // Store date options
                        popupAdd = webix.ui({
                            view: 'window', // Add window for adding templates
                            id: 'AddProviders', // Unique ID for the window
                            width: screen.width < 500 ? 350 : 450, // Responsive width
                            height: screen.width < 500 ? 600 : 250, // Responsive height
                            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
                            head: {
                                view: 'toolbar', // Toolbar for window header
                                cols: [
                                    {
                                        view: 'label',
                                        label: _('Añadir Plantilla'), // Label for the window
                                    },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide window on close
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center the window
                            modal: true, // Modal window
                            body: {
                                view: 'scrollview', // Scrollable body
                                scroll: 'y',
                                body: {
                                    view: 'form', // Form for adding templates
                                    id: 'addform', // Unique ID for the form
                                    width: screen.width < 500 ? 350 : 450, // Responsive width
                                    height: screen.width < 500 ? 600 : 200, // Responsive height
                                    elements: [
                                        {
                                            view: 'text',
                                            label: _('Tipo'), // Label for Type
                                            name: 'Type', // Field name
                                            required: true, // Required field
                                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                                            labelWidth: 150, // Label width
                                        },
                                        {
                                            view: 'combo', // Combo box for Language
                                            label: _('Idioma'), // Label for Language
                                            name: 'Language', // Field name
                                            required: true, // Required field
                                            labelWidth: 150, // Label width
                                            options: [
                                                {
                                                    id: 'es',
                                                    value: 'español (o castellano) (ES)', // Spanish option
                                                },
                                                {
                                                    id: 'en',
                                                    value: 'English (EN)', // English option
                                                },
                                            ],
                                        },
                                        {
                                            view: 'combo', // Combo box for Section
                                            label: _('Sección'), // Label for Section
                                            name: 'Section', // Field name
                                            options: datePopup, // Options from fetched data
                                            required: true, // Required field
                                            labelWidth: 150, // Label width
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: 'button', // Cancel button
                                                    value: _('Cancelar'), // Button label
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Hide window on cancel
                                                        $$('addform').setValues(
                                                            $$('addform').getCleanValues(), // Reset form values
                                                        );
                                                    },
                                                },
                                                {
                                                    view: 'button', // Save button
                                                    type: 'form',
                                                    value: _('Guardar'), // Button label
                                                    click: function ($e) {
                                                        var values = $$('addform').getValues(); // Get form values
                                                        values.Partner = id_partner; // Add partner ID to values
                                                        if (
                                                            $$('addform').validate() // Validate form
                                                        ) {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Set content type
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() +
                                                                        'Partners/AddTemplateEmailList',
                                                                    values, // Send form values
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message({
                                                                                title: _(
                                                                                    '¡Error!', // Error message title
                                                                                ),
                                                                                type: 'alert-error', // Error message type
                                                                                text: _(
                                                                                    'Ocurrio un error, comuniquese con soporte', // Error message text
                                                                                ),
                                                                            });
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var response = JSON.parse(
                                                                                text, // Parse response
                                                                            );
                                                                            if (
                                                                                !response.HasError // Check for errors
                                                                            ) {
                                                                                webix.message(
                                                                                    'Tipo de plantilla agregada satisfactoriamente.', // Success message
                                                                                );
                                                                                grid.clearAll(); // Clear grid
                                                                                grid.load(
                                                                                    url +
                                                                                        '?start=0&count=' +
                                                                                        grid.data.$pagesize +
                                                                                        filter, // Reload grid data
                                                                                );
                                                                            } else {
                                                                                webix.message({
                                                                                    title: _(
                                                                                        '¡Error!', // Error message title
                                                                                    ),
                                                                                    type: 'alert-error', // Error message type
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte', // Error message text
                                                                                    ),
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                            $$('addform').setValues(
                                                                $$('addform').getCleanValues(), // Reset form values
                                                            );
                                                            this.getTopParentView().hide(); // Hide window after saving
                                                        } else {
                                                            webix.message({
                                                                title: _(
                                                                    '¡Error!', // Error message title
                                                                ),
                                                                type: 'alert-error', // Error message type
                                                                text: _(
                                                                    'Completa los campos...', // Error message text
                                                                ),
                                                            });
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate(); // Validate fields on change
                                            },
                                        },
                                    },
                                },
                            },
                        });
                        popup = webix.ui({
                            view: 'window', // Add window for editing templates
                            id: 'editTemplate', // Unique ID for the window
                            width: screen.width < 500 ? 350 : 450, // Responsive width
                            height: screen.width < 500 ? 600 : 350, // Responsive height
                            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
                            head: {
                                view: 'toolbar', // Toolbar for window header
                                cols: [
                                    {
                                        view: 'label',
                                        label: _('Editar Plantilla'), // Label for the window
                                    },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide window on close
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center the window
                            modal: true, // Modal window
                            body: {
                                view: 'scrollview', // Scrollable body
                                scroll: 'y',
                                body: {
                                    view: 'form', // Form for editing templates
                                    id: 'editform', // Unique ID for the form
                                    width: screen.width < 500 ? 350 : 450, // Responsive width
                                    height: screen.width < 500 ? 600 : 250, // Responsive height
                                    elements: [
                                        {
                                            view: 'text',
                                            label: 'Id', // Label for ID
                                            name: 'Id', // Field name
                                            readonly: true, // Read-only field
                                            required: true, // Required field
                                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                                            labelWidth: 150, // Label width
                                        },
                                        {
                                            view: 'text',
                                            label: _('Tipo'), // Label for Type
                                            name: 'Type', // Field name
                                            readonly: false, // Editable field
                                            required: true, // Required field
                                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                                            labelWidth: 150, // Label width
                                        },
                                        {
                                            view: 'combo', // Combo box for Language
                                            label: _('Idioma'), // Label for Language
                                            name: 'Language', // Field name
                                            required: true, // Required field
                                            labelWidth: 150, // Label width
                                            options: [
                                                {
                                                    id: 'es',
                                                    value: 'español (o castellano) (ES)', // Spanish option
                                                },
                                                {
                                                    id: 'en',
                                                    value: 'English (EN)', // English option
                                                },
                                            ],
                                        },
                                        {
                                            view: 'combo', // Combo box for Section
                                            label: _('Sección'), // Label for Section
                                            name: 'Section', // Field name
                                            options: datePopup, // Options from fetched data
                                            required: true, // Required field
                                            labelWidth: 150, // Label width
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: 'button', // Cancel button
                                                    value: _('Cancelar'), // Button label
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Hide window on cancel
                                                    },
                                                },
                                                {
                                                    view: 'button', // Save button
                                                    type: 'form',
                                                    value: _('Guardar'), // Button label
                                                    click: function ($e) {
                                                        var values = $$('editform').getValues(); // Get form values
                                                        values.Partner = id_partner; // Add partner ID to values
                                                        if (
                                                            $$('editform').validate() // Validate form
                                                        ) {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Set content type
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() +
                                                                        'Partners/UpdateTemplateEmailList',
                                                                    values, // Send form values
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message({
                                                                                title: _(
                                                                                    '¡Error!', // Error message title
                                                                                ),
                                                                                type: 'alert-error', // Error message type
                                                                                text: _(
                                                                                    'Ocurrio un error, comuniquese con soporte', // Error message text
                                                                                ),
                                                                            });
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var response = JSON.parse(
                                                                                text, // Parse response
                                                                            );
                                                                            if (
                                                                                !response.HasError // Check for errors
                                                                            ) {
                                                                                webix.message(
                                                                                    'Tipo de plantilla actualizada satisfactoriamente.', // Success message
                                                                                );
                                                                                grid.clearAll(); // Clear grid
                                                                                grid.load(
                                                                                    url +
                                                                                        '?start=0&count=' +
                                                                                        grid.data.$pagesize +
                                                                                        filter, // Reload grid data
                                                                                );
                                                                            } else {
                                                                                webix.message({
                                                                                    title: _(
                                                                                        '¡Error!', // Error message title
                                                                                    ),
                                                                                    type: 'alert-error', // Error message type
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte', // Error message text
                                                                                    ),
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                            $$('editform').setValues(
                                                                $$('editform').getCleanValues(), // Reset form values
                                                            );
                                                            this.getTopParentView().hide(); // Hide window after saving
                                                        } else {
                                                            webix.message({
                                                                title: _(
                                                                    '¡Error!', // Error message title
                                                                ),
                                                                type: 'alert-error', // Error message type
                                                                text: _(
                                                                    'Completa los campos...', // Error message text
                                                                ),
                                                            });
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate(); // Validate fields on change
                                            },
                                        },
                                    },
                                },
                            },
                        });
                    }
                },
            });

        // Event listener for adding templates
        this.on(this.app, 'addTemplate:button', (filter) => {
            if (datePopup.length > 0) {
                $$('addform').clearValidation(); // Clear validation errors
                popupAdd.show(); // Show add template window
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message if no data
                    title: _('¡Error!'), // Error message title
                    type: 'alert-error', // Error message type
                });
            }
        });
    }
}

// FILE DOCUMENTED
